function StarIcon() {
  return (
    <svg
      width='18'
      height='17'
      viewBox='0 0 18 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.99163 0.166687C4.39163 0.166687 0.666626 3.90002 0.666626 8.50002C0.666626 13.1 4.39163 16.8334 8.99163 16.8334C13.6 16.8334 17.3333 13.1 17.3333 8.50002C17.3333 3.90002 13.6 0.166687 8.99163 0.166687ZM12.525 13.5L8.99996 11.375L5.47496 13.5L6.40829 9.49169L3.29996 6.80002L7.39996 6.45002L8.99996 2.66669L10.6 6.44169L14.7 6.79169L11.5916 9.48335L12.525 13.5Z'
        fill='#DCA859'
      />
    </svg>
  );
}

export { StarIcon };
